var psa_params = {
  psaParamsFilePath: "psa_params.json",
  psaParamsLocalFilePath: "psa_params_local.json",
  data: {}
};

psa_params.init = function(callback) {
  var ajaxTest = $.ajax({
    url: psa_params.psaParamsFilePath
    , global: false
    , dataType: "json"
    , async: true
    , success: function success(dataAjax, textStatusAjax, jqXHRAjax) {
          psa_params.data = dataAjax;

          if ( psa_params.data.isDoc == undefined ) {
              psa_params.loadPsaParamsLocal(callback);
          }
          else {
            callback.apply(this, []);
          }
    }
    , error: function fail() {
      callback.apply(this, []);
    }
  });
}

psa_params.loadPsaParamsLocal = function(callback) {
  var ajaxTest = $.ajax({
    url: psa_params.psaParamsLocalFilePath
    , global: false
    , dataType: "json"
    , async: true
    , success: function success(dataAjax, textStatusAjax, jqXHRAjax) {
      var data = {};
      data = dataAjax;

      if ( data.use_local_params == true ) {
        for ( var key in data ) {
          psa_params.data[key] = data[key];
        }
      }

      callback.apply(this, []);
    }
    , error: function fail() {
      callback.apply(this, []);
    }
  });
}
